<template>
  <div class="popup-wrap" :class="{ show: isOpen }" @click.self="close()">
    <div class="popup">
      <div class="popup-header p-3 text-center">
        <h3 class="font-16 bold m-0">Thông tin cột</h3>
      </div>
      <div class="popup-body px-2">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="text-center" style="width: 100px">Vị trí</th>
              <th>Tên cột</th>
              <th class="text-right" style="width: 220px">Chiều rộng cột</th>
              <th class="text-center" style="width: 60px">Ẩn / Hiện</th>
            </tr>
          </thead>
          <tbody style="overflow: auto; max-height: calc(100lvh - 200px)">
            <tr
              v-for="column in columns"
              :key="column.key"
              draggable
              :style="{
                border:
                  stepOver == column.key
                    ? '2px dashed green'
                    : '2px solid transparent',
              }"
            >
              <td class="text-center align-middle">
                <div class="d-flex">
                  <div class="mr-2 d-flex flex-column">
                    <i class="fa fa-chevron-up pointer" @click="moveUp(column.key)" />
                    <i class="fa fa-chevron-down pointer" @click="moveDown(column.key)" />
                  </div>
                  <span class="bold font-18">{{ sorts[column.key] }}</span>
                </div>
              </td>
              <td>
                <div>
                  <p class="m-0">{{ column.title }}</p>
                  <p class="sub-text">{{ column.key }}</p>
                </div>
              </td>
              <td class="align-middle">
                <input
                  class="form-control form-control-sm text-right"
                  placeholder="Chiều rộng: px hoặc %"
                  v-model="widths[column.key]"
                />
              </td>
              <td class="text-center align-middle">
                <check-box
                  v-model="views[column.key]"
                  @input="$forceUpdate()"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="popup-footer p-2 text-right">
        <button class="btn btn-basic pl-4 pr-4 mr-2" @click="close()">
          Đóng
        </button>

        <button
          class="btn btn-outline-primary pl-4 pr-4 mr-2"
          @click="makeDefault()"
        >
          Mặc định
        </button>

        <button class="btn btn-primary pl-4 pr-4 mr-2" @click="save()">
          <i class="fa fa-save" />
          Lưu lại
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
      columns: [],
      idDrag: "",
      stepOver: "",
      itemDrag: {},
      widths: {},
      views: {},
      sorts: {},
    }
  },
  props: ["tableName"],
  methods: {
    save() {
      const config = {
        order: this.columns.map((a) => a.key),
        views: this.views,
        widths: this.widths,
      }
      localStorage.setItem("config-" + this.tableName, JSON.stringify(config))
      this._ok()
      this.isOpen = false
    },
    makeDefault() {
      this.columns.forEach((a, index) => {
        this.views[a.key] = true
        this.widths[a.key] = a.width
        this.sorts[a.key] = index + 1
      })
    },
    onDropItem(event, newStep) {
      const tmp = newStep.sort
      newStep.sort = this.itemDrag.sort
      this.itemDrag.sort = tmp
      this.idDrag = ""
      this.stepOver = ""
      this.stepChange = null
      this.$forceUpdate()
    },
    open(config) {
      this.isOpen = true
      this.columns = config.columns
      this.columns.forEach((a, index) => {
        this.views[a.key] = true
        this.widths[a.key] = a.width
        this.sorts[a.key] = index + 1
      })

      const d = localStorage.getItem("config-" + this.tableName)
      if (d) {
        const data = JSON.parse(d)
        this.views = data.views || this.views
        this.widths = data.widths || this.widths
        this.sorts = data.sorts || this.sorts
      }
      this.$forceUpdate()
      return new Promise((resolve) => {
        this._ok = resolve
      })
    },
    moveUp(key){
      const index = this.columns.findIndex(a => a.key == key)
      if(index > 0){
        const tmp = this.columns[index - 1]
        this.columns[index - 1] = this.columns[index]
        this.columns[index] = tmp
        this.$forceUpdate()
      }
    },
    moveDown(key){
      const index = this.columns.findIndex(a => a.key == key)
      if(index < this.columns.length - 1){
        const tmp = this.columns[index + 1]
        this.columns[index + 1] = this.columns[index]
        this.columns[index] = tmp
        this.$forceUpdate()
      }
    },
    close() {
      this.isOpen = false
    },
  },
}
</script>
